import React, { useContext, useCallback } from 'react';
import NotificationRow from '@/components/notifications/NotificationRow';
import { Trans } from '@lingui/react/macro';
import { NavigationContextMenuContext } from '../../NavigationContextMenu';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import theme from './HeaderNotificationsButton.module.scss';
import { Button } from '@/components/Buttons';
import { INotification } from '@/types';

interface HeaderNotificationMenuProps {
    notifications: INotification[];
    onNotificationClick(notification: INotification): void;
    requestMoreNotifications?(): void;
}

const HeaderNotificationMenu: React.FC<HeaderNotificationMenuProps> = ({
    onNotificationClick,
    notifications,
    requestMoreNotifications,
}) => {
    const menuContext = useContext(NavigationContextMenuContext);
    const handleNotificationClick = useCallback(
        (notification: INotification) => {
            menuContext.toggle(false);
            triggerHandler(onNotificationClick, notification);
        },
        [menuContext, onNotificationClick]
    );

    return (
        <>
            {notifications.map((n) => (
                <NotificationRow key={n.id} notification={n} onClick={handleNotificationClick} />
            ))}

            {notifications.length === 0 && (
                <div className={theme.emptyMessage}>
                    <span className="text-missing">
                        <Trans>No notifications</Trans>
                    </span>
                </div>
            )}

            {notifications.length > 0 && requestMoreNotifications && (
                <Button className={theme.loadMoreButton} size="small" color="tertiary" onClick={requestMoreNotifications}>
                    <Trans>Load more</Trans>
                </Button>
            )}
        </>
    );
};

export default HeaderNotificationMenu;
